/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  return {
    switch: {
      width: '100%',
      height: 40,
      borderRadius: 10,
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      position: 'relative',
      cursor: 'pointer',
      // transition: 'background 1.3s ease',
    },
    switchOn: {
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
    },
    buttonLabel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    switchLabel: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      fontSize: 14,
      color: 'white',
      opacity: 0.5,
    },
    switchHandle: {
      width: '50%',
      height: 34,
      bosShadow:
        '5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.25) inset',
      background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
      borderRadius: 7,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: '4px',
      transition: 'left 0.3s ease',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: 14,
      color: 'white',
    },
    switchHandleOn: {
      left: 'calc(50% - 4px)',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
